export const FEATURE_FLAGS = {
	UI_ORACLE_CANDLES: true,
};
